let carousel;
let items;
const linkedItems = [];

function getLinks() {
  let link;

  for (let i = 0; i < items.length; i++) {
    link = items[i].querySelector('a');

    if (link !== null) {
      linkedItems.push(items[i]);
    }
  }

  addItemClickListeners();
}

function addItemClickListeners() {
  for (let i = 0; i < linkedItems.length; i++) {
    linkedItems[i].addEventListener('click', itemClick.bind(this, linkedItems[i]), false);
  }
}

function getItems() {
  items = carousel.querySelectorAll('.carousel-item');

  getLinks();
}

function itemClick(item, e) {
  if (window.google_tag_manager) {
    e.preventDefault();

    const dataAttribute = item.getAttribute('data-data-layer');

    const parsedData = JSON.parse(dataAttribute);

    pushDataLayer(parsedData, setLocation.bind(this, e.target.href));
  }
}

function pushDataLayer(data, callback) {
  window.dataLayer.push({
    event: 'banner_click',
    banner_name: data.banner_name,
    banner_pos: data.banner_pos,
    eventCallback() {
      callback();
    },
    eventTimeout: 2000,
  });

  // console.log for testing purposes only
  // console.log(window.dataLayer);
}

function setLocation(href, e) {
  window.location = href;
}

export default function() {
  const object = {
    init: element => {
      carousel = element;

      getItems();
    },
  };

  return object;
}
